import { AddedSearchFilters } from '../SearchState';
import { RootState } from '../../RootState';

const selectAddedProductFilters = (state: RootState): Array<AddedSearchFilters> =>
  state.search.addedSearchFilters;

export default selectAddedProductFilters;
